export default {
  items: [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Thống kê',
          icon: 'cil-speedometer',
          to: '/dashboard.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý thiết bị',
          icon: 'cil-devices',
          to: '/devices-management/list.html'
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Thao tác phát thanh',
          icon: 'cil-bullhorn',
          items: [
            {
              // _name: 'CSidebarNavItem',
              name: 'Phát thanh trực tiếp',
              // icon: 'cib-livestream',
              to: '/radio-activities/livestream.html'
            },
            {
              name: 'Phát thanh đặt lịch',
              to: '/radio-activities/managed-schedule.html',
            },
            // {
            //   name: 'Xử lý lịch trùng',
            //   to: '/radio-activities/managed-duplicate.html',
            // },
            {
              name: 'Nhật ký phát thanh',
              to: '/radio-activities/managed-history.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý ND & biên tập',
          icon: 'cil-file',
          items: [
            {
              name: 'Biên tập nội dung',
              to: '/media-management/managed-files.html',
            },
            {
              name: 'Biên tập danh sách phát',
              to: '/media-management/play-list.html',
            },
            {
              name: 'Chuyển đổi văn bản sang giọng nói',
              to: '/media-management/text-to-speech.html',
            },
            {
              name: 'Ghi âm giọng nói',
              to: '/media-management/record-files.html',
            },
            {
              name: 'Ghép tệp tin âm thanh',
              to: '/media-management/merge-files.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Báo cáo thống kê',
          icon: 'cil-book',
          items: [
            {
              name: 'Số lượng bản tin đã phát',
              to: '/report-management/broadcast.html',
            },
            {
              name: 'Tình trạng cụm loa',
              to: '/report-management/device.html',
            }
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản trị',
          icon: 'cil-settings',
          items: [
            {
              name: 'Nhật ký hoạt động',
              to: '/administrator/user-activity-log.html',
            },
            {
              name: 'Quản lý lĩnh vực',
              to: '/administrator/file-type.html',
            },
            {
              name: 'Quản lý tiến trình',
              to: '/administrator/thread.html',
            },
            {
              name: 'Quản lý hàng chờ',
              to: '/administrator/queue.html',
            },
            {
              name: 'Quản lý Cache',
              to: '/administrator/cache.html',
            },
            {
              name: 'Quản lý kênh số hóa',
              to: '/administrator/channel-digital.html',
            },
            {
              name: 'Quản lý Key',
              to: '/administrator/key-authentication.html',
            },
            {
              name: 'Quản lý SIM',
              to: '/administrator/sim.html',
            },
            // {
            //   name: 'Upload kiểm tra loa',
            //   to: '/administrator/sound-speaker.html',
            // },
            {
              name: 'Quản lý Version TB',
              to: '/administrator/version-fw.html',
            },
            {
              name: 'Quản lý thông tin xác thực TB',
              to: '/administrator/config-authentication.html',
            },
            {
              name: 'Quản lý cấu hình đồng bộ HTTTN',
              to: '/administrator/config-sync-htttn.html',
            },
            {
              name: 'Lịch sử request HTTTN',
              to: '/administrator/log-sync-htttn.html',
            },
            {
              name: 'Quản lý địa bàn',
              to: '/administrator/config-location.html',
            },
            {
              name: 'Quản lý NCC',
              to: '/administrator/config-supplier.html',
            },
            {
              name: 'Quản lý TTS',
              to: '/administrator/config-text-to-speech.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý tài khoản',
          icon: 'cil-people',
          items: [
            {
              name: 'Danh sách tài khoản',
              to: '/user-management/managed-users.html',
            },
            {
              name: 'Đổi mật khẩu',
              // icon: 'cil-user',
              to: '/user/reset-password.html'
            },
          ]
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Hướng dẫn sử dụng',
          icon: 'cil-hd',
          to: '/user-manual.html'
        },
      ]
    },
  ]
}
